import { render, staticRenderFns } from "./ColorKitHero.vue?vue&type=template&id=5c4c47bd&scoped=true&lang=pug&"
import script from "./ColorKitHero.vue?vue&type=script&lang=js&"
export * from "./ColorKitHero.vue?vue&type=script&lang=js&"
import style0 from "./ColorKitHero.vue?vue&type=style&index=0&id=5c4c47bd&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4c47bd",
  null
  
)

export default component.exports